import React, { useEffect, useState } from "react";
import axios from "../../api/axios";
import "./Row.css";
import YouTube from "react-youtube";
import apiUrl from "../../api/config.json";
import Movie from "./Movie/MovieCard";

const API_KEY = apiUrl.APIKey;

// const base_url = "https://image.tmdb.org/t/p/original";

function Row({ title, fetchUrl, isLargeRow }) {
	const [movies, setMovies] = useState([]);
	const [trailerUrl, setTrailerUrl] = useState("");
	const [isMessage, setMessage] = useState("");
	const [isActive, setIsActive] = useState(false);
	// const [isShown, setIsShown] = useState(false);

	useEffect(() => {
		// if [], run the code once when the page loads.
		async function fetchData() {
			const request = await axios.get(fetchUrl);
			setMovies(request.data.results || request.data.cast);
			return request;
		}
		fetchData();
	}, [fetchUrl]);

	const opts = {
		width: "100%",
		playerVars: {
			autoPlay: 1,
		},
	};

	function TrailerVideo(request) {
		if (request.data.results.length > 0) {
			setMessage("");
			const getTrailer = request.data.results.filter((result) => {
				return result.type === "Trailer" ? result.key : null;
				// if (result?.type === "Trailer") {
				// 	return result.key;
				// }
			});
			setTrailerUrl(getTrailer[0].key);
			return request;
		} else {
			setMessage("No trailer found");
		}
	}

	// Handle Movie UI
	const movieFocus = (movie) => {
		if (isActive === movie.id) {
			setIsActive(false);
		} else {
			setTrailerUrl(""); // Working
			setMessage(""); // Working
			setIsActive(movie.id);
		}
	};

	// Make the Movies bigger on click
	const handleMovieClick = (movie, e) => {
		if (trailerUrl) {
			setTrailerUrl(""); // Working
			setMessage(""); // Working
			// setIsActive(false);
		} else {
			async function fetchTrailer() {
				try {
					const request = await axios.get(
						`/movie/${movie.id}/videos?api_key=${API_KEY}&language=en-US`
					);
					TrailerVideo(request);
				} catch (err) {
					if (err.response) {
						const request = await axios.get(
							`/tv/${movie.id}/videos?api_key=${API_KEY}&language=en-US`
						);
						TrailerVideo(request);
					} else {
						console.log("No Movie found?");
					}
				}
			}
			fetchTrailer();
		}
	};

	return (
		<div className="row">
			<h2>{title}</h2>
			<div className="row__posters">
				{movies?.map(
					(movie) =>
						// This check if there is any broken image URL
						((isLargeRow && movie.poster_path) ||
							(!isLargeRow && movie.backdrop_path)) && (
							<Movie
								movie={movie}
								key={movie.id}
								isActive={isActive === movie.id}
								handleMovieClick={handleMovieClick}
								movieFocus={movieFocus}
							/>
						)
					)}
			</div>
			{trailerUrl && (
				<YouTube videoId={trailerUrl} id={trailerUrl} opts={opts} />
			)}
			{isMessage && (
				<div className="noTrailer">
					<h2>{isMessage}</h2>
				</div>
			)}
		</div>
	);
}

export default Row;
